import { Card, CardContent } from "@workspace/web-ui/components/card";

interface SnapshotProps {
  conditions: string;
  allergies: string;
  activeMeds: string;
  refills: number;
  avgWeekLoss: number;
  calorieBudget: number;
  workouts: number;
  target: number;
}

export default function SnapshotCards({
  conditions,
  allergies,
  activeMeds,
  refills,
  // avgWeekLoss,
  // calorieBudget,
  // workouts,
  // target,
}: SnapshotProps) {
  return (
    <div className="flex flex-col gap-4">
  {/* Medical Snapshot */}
  <Card className="w-full rounded-xl border-0 bg-[#E1FAEA] p-2 lg:p-4">
    <CardContent className="flex flex-col p-0">
      <h3 className="text-base font-medium">Medical Snapshot</h3>

      <span className="mt-2 inline-flex flex-wrap items-center text-sm text-gray-700">
        <span className="font-normal">Conditions:</span>{" "}
        <h6 className="mx-1 font-medium text-[#2D2F35]">{conditions || " --"}</h6>
      </span>

      <span className="mt-2 inline-flex flex-wrap items-center text-sm text-gray-700">
        <span className="font-normal">Allergies:</span>{" "}
        <h6 className="mx-1 font-medium text-[#2D2F35]">{allergies || " --"}</h6>
      </span>

      <span className="mt-2 inline-flex flex-wrap items-center text-sm text-gray-700">
        <span className="font-normal">Active Meds:</span>{" "}
        <h6 className="mx-1 font-medium text-[#2D2F35]">
          {activeMeds || " --"} {activeMeds && refills && `(${refills} refills)`}
        </h6>
      </span>
    </CardContent>
  </Card>

  {/* Wellness Stats */}
  {/* <Card className="w-full sm:w-1/2 rounded-xl border-0 bg-[#FEEBEB] p-4">
    <CardContent className="flex flex-col p-0">
      <h3 className="text-base font-medium">Wellness Stats</h3>

      <span className="mt-2 inline-flex flex-wrap items-center text-sm text-gray-700">
        <span className="font-normal">Avg Weekly Loss:</span>{" "}
        <h6 className="mx-1 font-medium text-[#2D2F35]">{avgWeekLoss} kg</h6>
      </span>

      <span className="mt-2 inline-flex flex-wrap items-center text-sm text-gray-700">
        <span className="font-normal">Calorie Budget:</span>{" "}
        <h6 className="mx-1 font-medium text-[#2D2F35]">{calorieBudget}</h6>
      </span>

      <span className="mt-2 inline-flex flex-wrap items-center text-sm text-gray-700">
        <span className="font-normal">Workouts:</span>{" "}
        <h6 className="mx-1 font-medium text-[#2D2F35]">
          {workouts} / {target} monthly target
        </h6>
      </span>
    </CardContent>
  </Card> */}
</div>

  );
}
